interface StatCardProps {
  value: string;
  label: string;
}

export function StatCard({ value, label }: StatCardProps) {
  return (
    <div className="flex h-full min-h-0 rounded-lg bg-[linear-gradient(135deg,#9333ea,#ec4899)] p-[2px]">
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-md bg-white px-1 py-3 text-center shadow-card-default">
        <p className="text-xl font-bold text-shark-gray-900">{value}</p>
        <p className="text-xs text-shark-gray-500">{label}</p>
      </div>
    </div>
  );
}
